import React from 'react'
import styled from 'styled-components'
import { colors } from '../../Shared/colors'
import { SharedLeadsFirst } from '../../Components/Leads/shared leads/SharedLeadsFirst'

export const SharedLeadsComponent = () => {
  return (
    <Main>
        <SharedLeadsFirst/>
        {/* <SharedLeadsDataTable/> */}
    </Main>
  )
}

const Main = styled.div`
  background: linear-gradient(135deg, ${colors.lightWhite} 0%, ${colors.inputWhite} 100%);
  min-height: 100vh;
  padding: 1rem 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  gap: 1rem;
`

